import { useThemeStore, THEMES } from '../stores/themeStore';

function getTheme() {
  try { return THEMES.find(t => t.key === useThemeStore.getState().chatTheme) ?? THEMES[0]; }
  catch { return THEMES[0]; }
}

// Proxy that reads theme values dynamically
export const colors = new Proxy({} as Record<string, string>, {
  get(_, prop: string) {
    const theme = getTheme();
    const map: Record<string, string> = {
      // Map colors keys to theme properties
      background: theme.appBg,
      surface: theme.surfaceBg,
      card: theme.cardBg,
      header: theme.headerBg,
      border: theme.borderColor,
      text: theme.textColor,
      textMuted: theme.textMuted,
      textSecondary: theme.textMuted + 'cc',

      // These stay constant across themes
      primary: '#4CAF50',
      secondary: '#FF6347',
      accent: '#39FF14',
      success: '#4CAF50',
      warning: '#FF9800',
      error: '#F44336',
      info: '#2196F3',

      // LCD
      lcdBg: theme.chatBg,
      lcdText: theme.otherTextColor,
      lcdBorder: theme.inputBorder,
      lcdNeon: '#39FF14',

      // System
      statusBar: theme.headerBg,

      // Battery
      batteryLow: '#F44336',
      batteryMedium: '#FF9800',
      batteryHigh: '#4CAF50',

      // Overlays
      overlay: 'rgba(0, 0, 0, 0.5)',
      overlayLight: 'rgba(0, 0, 0, 0.3)',
    };
    return map[prop] ?? '#888';
  },
}) as any;
